import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  filterType: {
    status: "",
    relatedRefundBranch: "",
    startDate: "",
    endDate: "",
    voucherType: "",
  },
  keyword: "",
  page: 1,
  limit: 10,
};
const voucherSlice = createSlice({
  name: "voucher",
  initialState,
  reducers: {
    setFilterType: (state, action) => {
      state.filterType = {
        ...state.filterType,
        ...action.payload,
      };
    },
    setPage: (state, action) => {
      state.page = action.payload;
    },
    setLimit: (state, action) => {
      state.limit = action.payload;
    },
    setSearch: (state, action) => {
      state.keyword = action.payload;
    },
    clearFilter: (state) => {
      state.filterType = {
        status: "",
        relatedRefundBranch: "",
        startDate: "",
        endDate: "",
        voucherType: "all",
      };
      state.page = 1;
      state.limit = 10;
    },
  },
});

export const { setPage, setLimit, setFilterType, clearFilter, setSearch } =
  voucherSlice.actions;
export default voucherSlice.reducer;
